/**
 * SOC 2 readiness rule set — V106-1-5 / ADR-0078 §4 (migration 508).
 *
 * Which readiness engine `soc2` runs is reviewed data, not code: the
 * program's current approved `program_rule_sets` row of family
 * `soc2-readiness` names it. v1 (508) is `{"engine":"objective"}` (points of
 * focus on the objective model); a revert is approving the next version
 * `{"engine":"framework"}` — append-only, no deploy. With no approved row the
 * manifest's `legacyEngine` (`framework`: every criterion, credited through
 * reviewed SEC-* edges) runs.
 */
import { z } from 'zod';
export const SOC2_READINESS_FAMILY = 'soc2-readiness';
export const SOC2_READINESS_SCHEMA = 'gacpro.program-rules.soc2-readiness/1';
export const Soc2ReadinessRulesV1 = z.object({
    engine: z.enum(['objective', 'framework']),
}).strict();
//# sourceMappingURL=soc2-readiness-rules.js.map